import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-pagination', 'title', 'Lappuses navigācija');
Labels.set('ui-pagination', 'previousPage', 'Iepriekšējā lapa');
Labels.set('ui-pagination', 'nextPage', 'Nākamā lapa');
Labels.set('ui-pagination', 'currentPage', 'Pašreizējā lapa');
Labels.set('ui-pagination', 'page', 'Lapa');
Labels.set('ui-pagination', 'show', 'Rādīt katrā lapā');
